module.exports = __webpack_public_path__ + "img/typing.e448fa13.gif";